var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"channel-partner-header",class:{ 'no-border' : _vm.noBorder }},[_c('div',{staticClass:"nav__logo"}),_c('img',{staticClass:"channel-partner-logo",attrs:{"src":_vm.logoSrc,"alt":(_vm.partnerName + " logo")}})])}
var staticRenderFns = []

export { render, staticRenderFns }